import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import { getSearchLinkQuery } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import createSearchQueryString from 'lib/search/createSearchQueryString';
import BackLink from 'components/BackLink';
import { useDataLayer } from 'hooks/useDataLayer';

const UnconnectedBackToSearchLink = ({ searchQuery }) => {
  const { emitInteractionEvent } = useDataLayer();
  const { location: searchLocation, searchType = 'list' } = searchQuery;
  const searchQueryString = createSearchQueryString(omit(searchQuery, ['searchType']));
  const labelText = `Hotels in ${searchLocation}`;

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Return Search Page', value: 'Link Selected' });
  }, [emitInteractionEvent]);

  return <BackLink to={`/search/${searchType}?${searchQueryString}`} label={labelText} onClick={handleOnClick} />;
};

UnconnectedBackToSearchLink.propTypes = {
  searchQuery: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  searchQuery: getSearchLinkQuery(state),
});

export default memo(connect(mapStateToProps)(UnconnectedBackToSearchLink));
